// Utils
import { deepSearchKey } from '../../../utils/deepSearchKey';
import { UK_LANGUAGE } from 'languages';

export const textByLang = (obj = {}, path = '', lang = UK_LANGUAGE, def = '') => {
  const langPath = `${path}_${lang}`;

  return deepSearchKey(obj, langPath) || deepSearchKey(obj, path) || def;
};

export default textByLang;
